import { applyMiddleware, compose, createStore, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import {
  createTransform,
  persistReducer,
  persistStore,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import usuario from './ducks/user';
import iot from './ducks/iot';
import parque from './ducks/park';
import app from './ducks/app';
import historic from './ducks/historic';
import notifications from './ducks/notifications';
import dashboard from './ducks/dashboard';
import aplicacao from './ducks/appliance';
import operacional from './ducks/operational';
import eventos from './ducks/events';
import primeiroNivel from './ducks/first-level/first-level-reducer';
import segundoNivel from './ducks/second-level/second-level-reducer';
import root from './sagas';

const { REACT_APP_REDUX_LOGGER: logger } = process.env;

// Persistencia seletiva: so guardamos campos "selecao" (qual cliente/parque
// o operador esta visualizando) + cache de mapa. Excluimos:
//  - conexoes: array de funcoes cleanup de subscription GraphQL — funcoes
//    nao sao serializaveis e seriam invalidas apos refresh de qualquer jeito.
//  - parqueRealtime, uchas, ebas, subscriptionHealth: dados live que
//    rehidratados ficariam stale; melhor refetchar.
const segundoNivelPersistConfig = {
  key: 'segundoNivel',
  storage,
  whitelist: [
    'clienteSelecionado',
    'parqueSelecionado',
    'zonaSelecionada',
    'filterStatus',
    'mapa',
  ],
};

const primeiroNivelPersistConfig = {
  key: 'primeiroNivel',
  storage,
  whitelist: ['mapa'],
};

// Iot: persiste APENAS o campo `variables` por thingName. Ignora
// `values` (live, refetcha sozinho via subscription) e `unsubscribe`
// (funcao — quebra JSON.stringify). Ganho: ao revisitar uma maquina ja
// vista, pulamos 2 HTTP requests (getVariableGroups + getAllVariables)
// e o chart parte direto pro fetch de historic.
const iotVariablesTransform = createTransform(
  (inboundState) => {
    if (!inboundState || typeof inboundState !== 'object') return inboundState;
    const out = {};
    Object.keys(inboundState).forEach((thingName) => {
      const slice = inboundState[thingName];
      if (slice && slice.variables) {
        out[thingName] = { variables: slice.variables };
      }
    });
    return out;
  },
  (outboundState) => outboundState,
  { whitelist: [] }
);
const iotPersistConfig = {
  key: 'iot',
  storage,
  transforms: [iotVariablesTransform],
};

const reducers = combineReducers({
  usuario,
  iot: persistReducer(iotPersistConfig, iot),
  parque,
  app,
  historic,
  notifications,
  dashboard,
  aplicacao,
  operacional,
  eventos,
  primeiroNivel: persistReducer(primeiroNivelPersistConfig, primeiroNivel),
  segundoNivel: persistReducer(segundoNivelPersistConfig, segundoNivel),
});

const sagaMiddleware = createSagaMiddleware();
const loggerMiddleware = createLogger();
const middleware = !logger
  ? applyMiddleware(thunkMiddleware, sagaMiddleware)
  : applyMiddleware(thunkMiddleware, sagaMiddleware, loggerMiddleware);

export const store = createStore(
  reducers,
  compose(
    middleware,
    window.REDUXDEVTOOLSEXTENSION ? window.REDUXDEVTOOLSEXTENSION() : (f) => f
  )
);

export const persistor = persistStore(store);

sagaMiddleware.run(root);
